import invariant from 'invariant';

const isFunction = (val) => typeof val === 'function';
const isObject = (val) => val !== null && typeof val === 'object' && !Array.isArray(val);
const conformsTo = (obj, shape) =>
  Object.keys(shape).every((key) => shape[key](obj[key]));

/**
 * Validate the shape of redux store
 */
export default function checkStore(store) {
  const shape = {
    dispatch: isFunction,
    subscribe: isFunction,
    getState: isFunction,
    replaceReducer: isFunction,
    runSaga: isFunction,
    injectedReducers: isObject,
    injectedSagas: isObject,
  };
  invariant(
    conformsTo(store, shape),
    '(app/utils...) injectors: Expected a valid redux store',
  );
}
